'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PromotionsprogrammtypResource = _require2.PromotionsprogrammtypResource;

module.exports.Promotionsprogrammtyp = function (_BaseEntity) {
  _inherits(Promotionsprogrammtyp, _BaseEntity);

  _createClass(Promotionsprogrammtyp, null, [{
    key: '__name__',
    value: function __name__() {
      return 'promotionsprogrammtyp';
    }
  }]);

  function Promotionsprogrammtyp(data) {
    _classCallCheck(this, Promotionsprogrammtyp);

    var _this = _possibleConstructorReturn(this, (Promotionsprogrammtyp.__proto__ || Object.getPrototypeOf(Promotionsprogrammtyp)).call(this));

    _this._entityName = 'de.ul.fob.domain.PromotionsprogrammTyp';
    _this.name = null;
    _this.typId = null;

    _this.promotionsprogrammTyp = null;
    _get(Promotionsprogrammtyp.prototype.__proto__ || Object.getPrototypeOf(Promotionsprogrammtyp.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Promotionsprogrammtyp, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'name', 'typId'],
        links: ['promotionsprogrammTyp']
      });
    }
  }, {
    key: 'fetchPromotionsprogrammTyp',
    value: function fetchPromotionsprogrammTyp() {
      return _get(Promotionsprogrammtyp.prototype.__proto__ || Object.getPrototypeOf(Promotionsprogrammtyp.prototype), 'genericResolve', this).call(this, 'promotionsprogrammTyp');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Promotionsprogrammtyp.prototype.__proto__ || Object.getPrototypeOf(Promotionsprogrammtyp.prototype), 'genericResolve', this).call(this, 'promotionsprogrammTyp')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PromotionsprogrammtypResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Promotionsprogrammtyp.prototype.__proto__ || Object.getPrototypeOf(Promotionsprogrammtyp.prototype), 'fetchQuery', this).call(this, PromotionsprogrammtypResource);
      }
    }
  }]);

  return Promotionsprogrammtyp;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/promotionsprogrammtyp.js
// module id = wT65
// module chunks = 0